import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";

const YearPage = ({ year }) => {
	const [content, setContent] = useState("");
	const [images, setImages] = useState([]);
	const [lightboxImage, setLightboxImage] = useState(null);

	useEffect(() => {
		// Fetch markdown content
		fetch(`/letters/${year}.md`)
			.then((res) => res.text())
			.then((text) => {
				// Extract image URLs from markdown
				const imgRegex = /!\[.*?\]\((.*?)\)/g;
				const foundImages = [];
				let match;

				while ((match = imgRegex.exec(text)) !== null) {
					foundImages.push(match[1]);
				}

				setImages(foundImages);
				setContent(text);
			})
			.catch(() => setContent("Content not available yet."));
	}, [year]);

	const openLightbox = (img) => {
		setLightboxImage(img);
	};

	const closeLightbox = () => {
		setLightboxImage(null);
	};

	return (
		<>
			<div className="content_wrapper">
				<div className="content">
					<div className="content__title">
						<h1>Christmas Letter {year}</h1>
					</div>
					<div className="content__text">
						<ReactMarkdown>{content}</ReactMarkdown>
					</div>
				</div>

				{images.length > 0 && (
					<div className="images">
						{images.map((img, idx) => (
							<img
								key={idx}
								src={img}
								alt={`${year} photo ${idx + 1}`}
								onClick={() => openLightbox(img)}
								style={{ cursor: "pointer" }}
							/>
						))}
					</div>
				)}
			</div>

			{lightboxImage && (
				<div className="lightbox" onClick={closeLightbox}>
					<div className="lightbox__content">
						<button className="lightbox__close" onClick={closeLightbox}>
							×
						</button>
						<img src={lightboxImage} alt="Full size" />
					</div>
				</div>
			)}
		</>
	);
};

export default YearPage;
